import React, { FC } from 'react';
import { WithStyle } from '@ch/common/utils';
import { FormInputProps } from './types';
import { FormInputStyled } from './input.styled';

export const FormInput: FC<FormInputProps> & WithStyle = ({ as: _as, ref: _ref, ...rest }) => {
  return <FormInputStyled {...rest} />;
};

FormInput.defaultProps = {
  $size: 'md',
  $variant: 'default',
  type: 'text',
  disabled: false,
  required: false,
  placeholder: 'Enter',
  $error: false,
};

FormInput.displayName = 'FormInput';
FormInput.Style = FormInputStyled;
